import { apiClient, type PageEntity, type TaxCategoryEntity } from '@/libs/api'

export type FetchTaxCategoriesQuery = {
  tenantKey: string
  isActive?: boolean | undefined
}

export type FetchTaxCategoriesResponse = {
  data: TaxCategoryEntity[]
  pagination: PageEntity | null
}

/**
 * 税区分マスタ一覧取得 API
 * sortOrder 順は BE 側で保証される想定（B案: 表示順 = `sortOrder`）。
 */
export const fetchTaxCategories = async (
  { tenantKey, isActive }: FetchTaxCategoriesQuery,
  signal?: AbortSignal
): Promise<FetchTaxCategoriesResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .tax_categories.$get({
      query: isActive === undefined ? undefined : { isActive },
      config: { signal }
    })
  return { data, pagination }
}
